/*
 * Functions for Forms
 * Copied and modified from: static_src/js/c2Archive/forms.js
 * Revisit the following methods:
 *   [ actionButtonPreview, appendShowAllButton, enableBatchCheckboxes,
 *   hide_add_link_when_depleted, iconPreview, markRowForDeletionOrNot,
 *   moveOffsetLabelsToLeftCol,
 *   setupSchedulingFields, splitElementsIntoColumns,
 *   addTerraformMappingFields, addToDataTableFormDialog,
 *   setUpKubernetesSettingsForm, addTerraformMappingFields,
 *   ]
 */

(function (c2, $, _) {
  "use strict";

  /*
   * Toggle Password feature for Password fields
   * Controled via Admin > Misc Settings > Toggle Password
   * When enabled, Password fields should get a show/hide toggle icon
   */
  function initPasswordFields() {
    // Disable existing handlers so we don't end up with multiple
    $(".toggle-password").off("click");
    // Toggle classes for either Bootstrap Icons (v5) or Font Awesome (legacy).
    function toggleEyeIcon($eye) {
      if ($eye.hasClass("bi-eye") || $eye.hasClass("bi-eye-slash")) {
        $eye.toggleClass("bi-eye bi-eye-slash");
      } else {
        $eye.toggleClass("fa-eye fa-eye-slash");
      }
    }
    // Show the password and set a timeout to hide it again
    function show($eye, $input) {
      toggleEyeIcon($eye);
      $input.attr("type", "text");
      var timeoutId = setTimeout(function () {
        hide($eye, $input);
      }, $eye.attr("delay"));
      $eye.attr("timeout", timeoutId);
    }
    // Hide the password and clear the timeout if it exists
    function hide($eye, $input) {
      toggleEyeIcon($eye);
      $input.attr("type", "password");
      var timeoutId = $eye.attr("timeout");
      clearTimeout(timeoutId);
      $eye.removeAttr("timeout");
    }
    $(".toggle-password").click(function () {
      var $eye = $(this);
      var $input = $("#" + $eye.attr("toggle"));
      if ($input.attr("type") == "password") {
        show($eye, $input);
      } else {
        hide($eye, $input);
      }
    });
  }
  /*
   * Disable buttons for forms on keypress
   * Accounts for some buttons that may be links
   */
  const spinner = c2.spinners.spinner;

  function disableKeypressOnSubmit($scope) {
    // Swallows only the next Enter keypress on $scope, to stop a double-tapped
    // Enter from causing a duplicate submit (and the CSRF error that follows).
    var $target = $scope && $scope.length ? $scope : $(document);
    $target.off("keypress.disableOnSubmit").one("keypress.disableOnSubmit", function (e) {
      if (e.which === 13) {
        e.preventDefault();
        return false;
      }
    });
  }

  function disableBtnOnClick() {
    $(".btn").on("click", function (e) {
      if ($(this).is("a")) {
        $(this).addClass("disabled");
        $(this).html(spinner);
        disableKeypressOnSubmit($(this).closest("form"));
      }
    });
    $("form").on("submit", function (e) {
      $(this).find(":submit").prop("disabled", true);
      $(this).find(":submit").html(spinner);
      disableKeypressOnSubmit($(this));
    });
  }

  // Required to avoid "ManagementForm data is missing or has been tampered
  // with" ValidationError on server side.
  // Used by orderForm.js
  function makeFormsetManagementData(formCount) {
    return {
      'form-TOTAL_FORMS': formCount,
      'form-INITIAL_FORMS': 0,
      'form-MAX_NUM_FORMS': 1000
    };
  }

  // Actions with source code (plugin, remote script) may have a file uploaded
  // or point at a URL.  Form enables/disables fields based on where the code
  // comes from.
  function setupActionFileFields() {
    var $fileLocation = $('input[name=file_location]');
    var $uploadFields = $('.upload-widget').find('#id_module_file, #browse_button, .js-clear, #module_file-current a');
    var $externalUrlFields = $('#id_source_code_url');
    // Terraform specific fields
    var $localPathFields = $('#id_local_path');
    var $externalGitUrlFields = $('#id_git_source_code_url');

    // Improve form layout by putting the sub-fields into the radio labels
    // and moving the File location help text above the choices.
    function moveFileFieldsIntoRadioLabels() {
      var uploadLabel = $('#div_id_file_location [value="upload"]').parent()
      $('#div_id_module_file').appendTo(uploadLabel);

      var urlLabel = $('#div_id_file_location [value="url"]').parent();
      $('#div_id_source_code_url').appendTo(urlLabel);

      // Terraform specific options
      // Terraform also allows users to point to a git repo
      var gitUrlLabel = $('#div_id_file_location [value="git"]').parent()
      $('#div_id_git_source_code_url').appendTo(gitUrlLabel);
      $('#div_id_branch').appendTo('#div_id_git_source_code_url');

      // Add spacing below the git URL textarea's own wrapper (the
      // <div class="col-lg-9"> directly around #id_git_source_code_url,
      // not the outer #div_id_git_source_code_url row), since that's what
      // sits directly above the now-appended Branch field. Defensively
      // strip any existing mb-* class first — a later utility class (e.g.
      // "mb-3") wins the CSS cascade over "mb-2" regardless of class order,
      // so a plain addClass('mb-2') would silently no-op if one were ever
      // present here.
      $('#div_id_git_source_code_url > .col-lg-9')
        .removeClass(function (i, css) {
          return (css.match(/(^|\s)mb-\d+/g) || []).join(' ');
        })
        .addClass('mb-2');

      // #div_id_branch is itself a Bootstrap .row (label + col-lg-9 field),
      // and nesting a .row inside the .row above leaves it sized by its own
      // content (flex-basis: auto) rather than the parent's full width, so
      // the branch input doesn't reach as far right as the git URL textarea
      // above it. Its label is empty (label="" in TerraformOperationForm),
      // so drop it and flatten the field column to a plain full-width block
      // instead of fighting the nested grid math.
      $('#div_id_branch').removeClass('row').children('label').remove();
      $('#div_id_branch > [class*="col-lg-"]')
        .removeClass(function (i, css) {
          return (css.match(/(^|\s)col-lg-\d+/g) || []).join(' ');
        })
        .addClass('w-100');

      // Terraform has the concept of a local path on disk
      var localPathLabel = $('#div_id_file_location [value="local"]').parent()
      $('#div_id_local_path').appendTo(localPathLabel);
    };

    moveFileFieldsIntoRadioLabels();

    function morphFields() {
      var fileLocation = $fileLocation.filter(':checked').val();

      // Define a map of fileLocation values and JQuery objects
      var labels = {
        upload: $('#div_id_module_file'),
        url: $('#div_id_source_code_url'),
        later: null,
        local: $('#div_id_local_path'),
        git: $('#div_id_git_source_code_url'),
      };

      // Define a map of fileLocation values and Fields
      var fields = {
        upload: $uploadFields,
        url: $externalUrlFields,
        later: null,
        local: $localPathFields,
        git: $externalGitUrlFields,
      };

      function showOnly(location) {
        // We have two separate ways of hiding things. I'm not sure why, but that's how it is.
        // Refactors happen in baby steps sometimes. :shrug:
        // Iterate over all fields and hide them.
        $.each(labels, function (_, id) {
          if (id != null) { id.hide(); }
        });
        if (labels[location] != null) {
          // Show only the field we were asked to show.
          labels[location].show();
        }

        // Do the same loop for the `fields` map above
        $.each(fields, function (_, field) {
          if (field != null) { field.prop('disabled', true).addClass('disabled'); }
        });
        if (fields[location] != null) {
          // Leave only the one we want enabled
          fields[location].prop('disabled', false).removeClass('disabled');
        }
      };

      showOnly(fileLocation);
    }

    $fileLocation.on('change', morphFields);
    morphFields();
    $('#dialog-modal .modal-dialog').addClass('modal-wide');
  }


  // Web hook action form morphs based on the selected auth type.
  function setupWebHooksForm() {
    var $auth_method = $('select[name=authentication_method]');
    var $basic_fields = $('input[name=http_username], input[name=http_password]');
    var $token_fields = $('input[name=auth_header_name], input[name=auth_header_value]');

    function morphAuthFields() {
      var auth_method = $auth_method.val();
      if (auth_method == 'none') {
        $basic_fields.prop('disabled', true).closest('.form-group').hide();
        $token_fields.prop('disabled', true).closest('.form-group').hide();

      } else if (auth_method == 'basic') {
        $basic_fields.prop('disabled', false).closest('.form-group').show();
        $token_fields.prop('disabled', true).closest('.form-group').hide();

      } else if (auth_method == 'token') {
        $basic_fields.prop('disabled', true).closest('.form-group').hide();
        $token_fields.prop('disabled', false).closest('.form-group').show();
      }
    }

    $auth_method.on('change', morphAuthFields);
    morphAuthFields();
    $('#dialog-modal .modal-dialog').addClass('modal-wide');
  }

  /***************** Batch checking by column and row *****************/

  /* Check all or none of the subjects in the column of the clicked batch
   * checkbox.
   */
  function toggleAllInColumn(e) {
    var $checkbox = $(this);
    var check = $checkbox.prop('checked');
    var colNum = $checkbox.closest('th').prevAll().length;
    $checkbox.closest('table').find('tbody tr:visible').each(function (i) {
      var $input = $(this).children().eq(colNum).find('input');
      if ($input.prop('checked') != check) {
        $input.trigger('click');
      }
    });
  }


  function toggleAllInRow(e) {
    var $control = $(this);
    var $row = $control.closest('tr');
    var check = $control.prop('checked');
    $row.find('input:not(.check-row)').prop('checked', check);
  }

  function updateBatchCheckboxes(formsetContainer) {
    var dt = $(formsetContainer).DataTable();
    if (dt.isSingleSelect()) {
      // Table is in single select mode, skipping batch checkbox update
      return;
    }
    var $control, colNum, $subjects, allChecked, $allColumns, $tdColumns;
    $(formsetContainer).find('.check-column').each(function (i) {
      $control = $(this);
      colNum = $control.closest('th').prevAll().length;
      $subjects = $(formsetContainer).find('tbody tr:visible').find('td:eq(' + colNum + ') input');
      allChecked = ($subjects.length > 0 && $subjects.length == $subjects.filter(':checked').length);
      $control.prop('checked', allChecked);
    });

    $(formsetContainer).find('.check-row').each(function (i) {
      $control = $(this);
      $subjects = $control.closest('tr').find('td input:not(.check-row):visible');
      allChecked = ($subjects.length > 0 && $subjects.length == $subjects.filter(':checked').length);
      $control.prop('checked', allChecked);
    });
  }

  /* This is called by c2.dataTables to set up standard behaviors every time a page is drawn.
   * Namespaced so re-invoking on every redraw (see drawCallback in datatables.js) replaces
   * the previous handlers instead of stacking duplicate ones, which would otherwise fire
   * toggleAllInRow/toggleAllInColumn once per accumulated handler on a single click.
   */
  function enableBatchCheckboxes(container) {
    var $container = $(container);
    $container.off('.batchCheckboxes');
    $container.on('click.batchCheckboxes', '.check-column', toggleAllInColumn);
    $container.on('click.batchCheckboxes', '.check-row', toggleAllInRow);

    // When any subject checkboxes in the table body change, update the row & column batch
    // checkboxes to reflect the new state (i.e. checked if all boxes in a row or column are
    // selected).
    $container.on('change.batchCheckboxes', 'tbody input:checkbox:not(.check-column)', function (e) {
      updateBatchCheckboxes(container);
    });

    updateBatchCheckboxes(container);
  }

   function initPowerScheduleForm(wrapperId='action_form') {
    const $powerScheduleModalBody = $(`#${wrapperId}`);

    // Update the IDs of existing power schedule fields to include the prefix
    const $fields = $powerScheduleModalBody.find(".power-schedule-fields");
    const $addButton = $(`#${wrapperId}-add-power-schedule`);
    const $origSchedFields = $powerScheduleModalBody.find(".power-schedule").eq(0);
    // create new schedule fields
    $addButton.click(function(e) {
      e.preventDefault();
      //copy the last fieldset, if there is one
      let $scheduleTemplate = $powerScheduleModalBody.find(".power-schedule").last();
      // if not, the original was deleted, but we stored in a variable on init,
      // so use that instead
      if($scheduleTemplate.length === 0) {
        $scheduleTemplate = $origSchedFields
      }
      const $clone = $scheduleTemplate.clone();
      const origId = $clone.prop('id');
      const idNo = parseInt(origId.split('_')[1])
      const newIdNo = idNo + 1

      // update id and classes
      const id = origId.replace(/\d/, newIdNo);
      $clone.prop('id', id);
      $clone.addClass("new-schedule")

      // remove any error messages
      $clone.find(".errorlist").remove()

      // reset selects
      $clone.find("select").each(function() {
        let name = $(this).prop("name");
        name  = name.replace(/\d/, newIdNo);
        $(this).prop("name", name)
        $(this).attr('id', `id_${name}`)
        $(this).val(0);
      });

      $fields.append($clone);
    });

    $fields.on('click', '.delete-schedule', function() {
      const $parent = $(this).parent();
      const $deletedInput = $powerScheduleModalBody.find('input[name="deleted_schedules"]')
      const deletedVal = $deletedInput.val()
      const schedName = $parent.attr("id")

      if(! $parent.hasClass("new-schedule")) {
        $deletedInput.val(deletedVal+schedName+",")
      }
      $parent.remove()
    });
  }

  /* Click handler for order actions such as duplicate, cancel, approve.
  * Submits the form containing the icon/button and passes the target's
  * data-action attr value in a hidden input with the submitted form.
  */
  function doOrderAction(e) {
    // prevent event bubbling and possible double-submit in IE
    e.preventDefault();

    var $icon = $(e.target);
    // clear button has confirmation step
    if ($icon.hasClass('bi-x-lg')) {
      var answer = confirm("Remove all items from this order (cannot be undone)? ");
      if (!answer) {
        return false;
      }
    }
    c2.spinners.showSpinner({selector: '#content', fade: true, block:true})
    var action = $icon.data('action');
    var theform = $icon.closest('form');
    theform.find('input[name="action"]').val(action);
    theform.submit();
  }

  function setUpKubernetesSettingsForm() {
    var authTypeSelector = "input[name=auth_type]";
    var $auth_type = $(authTypeSelector);

    var password_field = "#div_id_servicepasswd";
    var token_field = "#div_id_bearer_token";
    var ca_field = "textarea[name=ca_file_contents]";
    var key_field = "textarea[name=key_file_contents]";
    var cert_field = "textarea[name=cert_file_contents]";

    var allFields = [password_field, token_field, ca_field, key_field, cert_field];

    var fieldsByAuthType = {
      "PASSWORD": [password_field],
      "TOKEN": [token_field],
      "CERTIFICATE": [ca_field, key_field, cert_field],
    };

    function disableFields(fieldsToEnable) {
      for (var i = 0; i < allFields.length; i++) {
        var field = allFields[i];
        if (!fieldsToEnable.includes(field)) {
          $(field).prop("disabled", true).closest(".form-group, .mb-3").hide();
        }
      }
    }

    function showAndEnableField(field) {
      $(field).prop("disabled", false).closest(".form-group, .mb-3").show();
    }

    function morphAuthType() {
      var auth_type = $(authTypeSelector).filter(":checked").val();
      var fieldsToEnable = fieldsByAuthType[auth_type];
      for (var i = 0; i < fieldsToEnable.length; i++) {
        showAndEnableField(fieldsToEnable[i]);
      }
      disableFields(fieldsToEnable);
    }

    function moveFieldsIntoRadioLabel() {
      // Look up each radio option's own label via its input's value, rather
      // than a fixed label:eq(N) index. RadioSelect renders its own field
      // label as a <legend> (Widget.use_fieldset = True), not a <label>, so
      // "#div_id_auth_type label" only ever matches the 3 option labels
      // (indices 0-2) -- a fixed eq(1)/eq(2)/eq(3) assumption silently
      // targeted the wrong (or a nonexistent) label.
      function radioLabel(value) {
        return $("#div_id_auth_type input[name=auth_type][value=" + value + "]")
          .closest(".form-check")
          .find("label.form-check-label");
      }

      var certLabel = radioLabel("CERTIFICATE");
      $("#div_id_ca_file_contents").appendTo(certLabel);
      $("#div_id_cert_file_contents").appendTo(certLabel);
      $("#div_id_key_file_contents").appendTo(certLabel);

      var tokenLabel = radioLabel("TOKEN");
      $("#div_id_bearer_token").addClass("nested-radio-field").appendTo(tokenLabel);

      var passwdLabel = radioLabel("PASSWORD");
      $("#div_id_servicepasswd").addClass("nested-radio-field").appendTo(passwdLabel);

      // Drop the field_class wrapper's right padding so the radio column
      // reaches the same right edge as other fields in the dialog.
      $("#div_id_auth_type").children("div").addClass("pe-0");

      // Password/Bearer Token labels stretch full width so their nested
      // input lines up consistently; Certificate's label is left alone.
      passwdLabel.addClass("w-100");
      tokenLabel.addClass("w-100");

      $("#div_id_ca_file_contents").addClass("mb-2 mt-2");

      // Narrow the Certificate label/value column split from the form's
      // global 3/9 (lg+ only) ratio to a 2/10 ratio that applies at every
      // breakpoint, since these fields now live in the cramped nested
      // radio label rather than a full dialog-width row.
      $(
        "#div_id_ca_file_contents > label," +
          "#div_id_cert_file_contents > label," +
          "#div_id_key_file_contents > label"
      )
        .removeClass("col-lg-3")
        .addClass("col-2");

      $(
        "#div_id_ca_file_contents > .col-lg-9," +
          "#div_id_cert_file_contents > .col-lg-9," +
          "#div_id_key_file_contents > .col-lg-9"
      )
        .removeClass("col-lg-9")
        .addClass("col-10");
    }

    moveFieldsIntoRadioLabel();
    $auth_type.on("change", morphAuthType);
    morphAuthType();
  }

  // Ensure all selected rows from the DataTable are serialized along with the
  // form's data.  Also remove duplicate parameter values, which can happen
  // when some selected rows are visible in the DOM and thus included by the
  // form.  So [{name: 'param', value:1}, {name: 'param', value: 1}, ...]
  // becomes [{name: 'param', value:1}, ...]. Return serialized data in the
  // form of a urlencoded querystring.
  function serializeFormAndTableSelection($form, $table) {
    var dt = $table.DataTable();
    var serialized = '',
      // Start by serializing the entire form. This may also include some
      // visible dataTable rows if the table is wrapped by the form.
      formData = $form.serializeArray(),
      // Serialize inputs in selected rows across all pages (DT 2.x API)
      tableData = $(dt.rows({selected: true}).nodes())
                    .find('input,select')
                    .serializeArray(),
      params,
      distinct;

    if ($table.hasClass('clickable')) {
      // Handle clickable paginated tables where selected rows have a checkbox
      // and may not be visible (thus not included in tableData)
      var visibleSelectedValues = $(dt.rows({selected: true}).nodes())
            .find('input.selector')
            .map(function () { return $(this).val(); })
            .toArray();
      var savedValues = (dt.settings()[0].oLoadedState || {}).customRows || [];
      var selectedValues = _.union(visibleSelectedValues, savedValues);
      var $selector = $(dt.rows().nodes()).find('input.selector').first();
      if ($selector.length) {
        _.forEach(selectedValues, function (val) {
          tableData.push({ name: $selector[0].name, value: val });
        });
      }
    }
    /*
     * Combine all params and remove any duplicate objects from the list

        E.g. this: [ {name: 'a', value: 1},
                    {name: 'a', value: 2},
                    {name: 'b', value: 'bear'},
                    {name: 'b', value: 'bear'} ]
        Returns:
                  [ {name: 'a', value: 1},
                    {name: 'a', value: 2},
                    {name: 'b', value: 'bear'} ]
      */
    params = _.union(tableData, formData);
    distinct = _.uniq(params, false, function (param, i, c) {
      return param.name + '::' + String(param.value);
    });


    // turn the {name: 'n', value: v} objects into {'n': v} objects
    distinct = _.map(distinct, function (param) {
      var obj = {};
      obj[param.name] = param.value;
      return obj;
    });

    // stringify objects (each key/value already URL-encoded) and join into one
    return _.map(distinct, c2.querystring.stringify).join('&');
  }

  // "Now" as wall-clock fields (year/month/.../seconds) in an IANA zone,
  // expressed as a Date object whose *local* getters (getHours(), etc, which
  // always read in the browser's own zone) return those fields. This is a
  // deliberate mismatch with the Date's real UTC instant: it exists only so
  // it can be compared, field-by-field, against a bs5-datetimepicker draft
  // that represents a wall-clock reading in that same target zone.
  function nowInZone(tzName) {
    // A blank selection isn't "no zone" -- both scheduling forms' clean()
    // treat a blank submitted time_zone as UTC (`... or "UTC"`), so the
    // client floor has to agree with that rather than falling back to the
    // browser's own zone.
    tzName = tzName || 'UTC';
    try {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: tzName, hour12: false,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      }).formatToParts(new Date());
      var get = function (type) {
        var p = _.find(parts, function (x) { return x.type === type; });
        return p ? p.value : '0';
      };
      var hour = get('hour');
      if (hour === '24') hour = '00'; // some locales render midnight as 24
      return new Date(+get('year'), +get('month') - 1, +get('day'), +hour, +get('minute'), +get('second'));
    } catch (e) {
      return new Date();
    }
  }

  // TZ_CHOICES (settings.py) is a curated ~26-entry list using legacy-style
  // IANA identifiers (e.g. "US/Eastern"), while Intl.DateTimeFormat resolves
  // the browser's zone to its canonical modern name (e.g. "America/New_York")
  // -- a literal string match between the two almost never succeeds, even
  // though "US/Eastern" IS a tzdata alias for "America/New_York". Comparing
  // each option's own canonicalization catches those aliases; a select whose
  // real zone isn't in the curated list at all returns null (no match), so
  // the caller can blank the field rather than force a wrong one.
  function findTzChoice($select, ianaZone) {
    var match = null;
    $select.find('option[value]').each(function () {
      if (!this.value || match) return;
      try {
        if (new Intl.DateTimeFormat('en-US', { timeZone: this.value }).resolvedOptions().timeZone === ianaZone) {
          match = this.value;
        }
      } catch (e) { /* not a recognized IANA zone string; skip */ }
    });
    return match;
  }

  function setupSchedulingFields() {
    var $runOption = $('input[name=run_option]');
    var $scheduledDate = $('input[name=scheduled_time]');
    var $timeZone = $('#id_time_zone');

    // Only default to the browser's local time zone on a genuinely fresh
    // dialog. The server only renders data-tz-autodetect when the form is
    // unbound; a dialog redisplayed after a validation error re-binds this
    // same script against the user's already-submitted selection (e.g.
    // "UTC") without that attribute, so it's left alone here -- overwriting
    // it would silently discard their choice on every failed submit. (A
    // plain "is it blank" check doesn't distinguish the two: neither
    // scheduling form's time_zone field renders a blank option first, so
    // .val() is already a real zone like "US/Samoa" or "UTC" even on a
    // fresh dialog.)
    if ($timeZone.is('[data-tz-autodetect]')) {
      var browserZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var matchingChoice = findTzChoice($timeZone, browserZone);
      // No match (e.g. the browser is in a zone this curated list doesn't
      // cover at all) -- blank the field rather than leave the server's
      // arbitrary first-choice selection (US/Samoa or UTC) looking like a
      // deliberate, correct default.
      $timeZone.val(matchingChoice || '').change();
    }

    // The scheduled_time picker's data-min-date="now" floors against the
    // browser's own clock, but the server interprets the submitted
    // wall-clock value in whatever zone is selected above -- so the floor
    // has to move with that selection, not sit fixed on browser-local now.
    function applyZoneAwareMinDate() {
      var inst = $scheduledDate.data('bs5dtp');
      // Guard rather than initialize: this can run before autoInit wires up
      // the picker (extra_onready_js runs first -- see v5/dialogs/dialog.html),
      // and constructing one here would take over before autoInit had a
      // chance to build the properly-configured instance from this field's
      // data-* attributes.
      if (!inst) return;
      // Pass a function, not a computed Date: setNowOverride() calls this
      // fresh on every floor/ceiling check, so the picker always reads the
      // Time Zone select's *current* value and the actual current moment,
      // rather than pinning both to whatever they were when this ran.
      inst.setNowOverride(function () { return nowInZone($timeZone.val()); });
    }
    $timeZone.on('change', applyZoneAwareMinDate);
    // Deferred so it runs after the picker's own auto-init, which happens
    // synchronously right after this function returns.
    setTimeout(applyZoneAwareMinDate, 0);

    // Detect DST without moment.js: compare Jan/Jul offsets to current
    var now = new Date();
    var jan = new Date(now.getFullYear(), 0, 1);
    var jul = new Date(now.getFullYear(), 6, 1);
    var isDST = now.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    $('#id_daylight_savings').prop('checked', isDST);

    function morphFields() {
      var selectedOption = $runOption.filter(':checked').val();

      if (selectedOption == 'now') {
        $('#div_id_scheduled_time').hide();
        $('#div_id_time_zone').hide();
        $('#div_id_daylight_savings').hide();
      } else if (selectedOption == 'later') {
        $('#div_id_scheduled_time').show();
        $('#div_id_time_zone').show();
        var month = new Date($scheduledDate.val()).getMonth();
        // Months 2,3,9,10 (Mar,Apr,Oct,Nov) are ambiguous for DST transitions
        var AMBIGUOUS_MONTHS = [2, 3, 9, 10];
        if (AMBIGUOUS_MONTHS.includes(month)) {
          $('#div_id_daylight_savings').show();
        } else {
          $('#div_id_daylight_savings').hide();
        }
      }
    }

    $runOption.on('change', morphFields);
    $scheduledDate.on('change', morphFields);
    morphFields();
  }

  /* Dynamically update the preview of an action button with icon
   * based on input field values.  Used by server and resource action edit
   * forms (i.e. ButtonActionMixin).
   */
  function actionButtonPreview() {
    var $preview = $('<button id="preview" class="btn btn-default"></button>');
    $preview.on('click', function (e) { e.preventDefault(); });

    var $xc = $('#id_extra_classes');
    var $btnpreview = gettext('Button preview');
    $xc.closest('.form-group').after(
      '<div class="row form-group">' +
      '  <label class="col-form-label col-lg-3 text-lg-end">' + $btnpreview + '</label>' +
      '  <div id="preview-wrap" class="col-lg-9">' +
      '  </div>' +
      '</div>');
    $('#preview-wrap').html($preview);

    var $label = $('#id_label');

    function updatePreview() {
      var classes = $xc.val();
      var $icon = $('<i id="preview-icon"></i>');
      $preview.html($icon);
      var badChars = /['";\/><]/g;
      $icon.addClass(classes.replace(badChars, ''));
      $icon.after('&nbsp;&nbsp;' + $label.val().replace(badChars, ''));
    }

    updatePreview();
    $xc.on('keyup', updatePreview);
    $label.on('keyup', updatePreview);
    $('#dialog-modal .modal-dialog').addClass('modal-wide');
  }

  /* Dynamically update the preview of a resource type icon based on what
   * the user types in the icon field.
   */
  function iconPreview() {
    var $preview = $('<span id="icon-preview"></span>');
    var $iconField = $('#id_icon');
    $iconField.closest('.form-group').after(
      '<div class="row form-group">' +
      '  <label class="col-form-label col-lg-3 text-lg-end">Icon preview</label>' +
      '  <div id="preview-wrap" class="col-lg-9">' +
      '  </div>' +
      '</div>');
    var $previewFormGroup = $iconField.closest('.form-group').next();
    $('#preview-wrap').html($preview);

    function updatePreview() {
      var classes = $iconField.val();
      if (classes) {
        var badChars = /['";\/><]/g;
        $preview.removeClass();
        $preview.addClass(classes.replace(badChars, ''));
        $previewFormGroup.show();
      } else {
        $previewFormGroup.hide();
      }
    }

    updatePreview();
    $iconField.on('keyup', updatePreview);
    $('#dialog-modal .modal-dialog').addClass('modal-wide');
  }

  function addTerraformMappingFields() {
    $.map($('label'), function (l) { $(l).text(function (i, text) { return text.replace(/CTV_/, ''); }); });
    var customFields = $('div[id^="div_id_custom"]');
    $.map(customFields, function (customField) { $(customField).hide(); });
    var showNext = function () {
      $('div[id^="div_id_custom_key"]:hidden:first').show();
      $('div[id^="div_id_custom_value"]:hidden:first').show();
    };
    $('.modal-footer:first').prepend('<button id="add_button" type="button" class="btn btn-primary">Add Variable</button>');
    $('#add_button:first').click(showNext);
  }

  function addToDataTableFormDialog(fieldName) {
    const createFragment = (id) => `
        <tr>
            <td>
              <input
                type="checkbox"
                id="custom_checkbox_${id}"
                name="${fieldName}"
                checked
                disabled
              />
            </td>
            <td>
              <input
                type="text"
                id="custom_text_${id}"
                name="${fieldName}"
              />
            </td>
        </tr>
      `;

    const addRow = (() => {
      let currentId = 0;
      return () => {
        currentId++;
        const newFragment = createFragment(currentId);
        $('#checkbox-select-multiple > tbody:last-child').append(newFragment);
        // Updating the input field updates the checkbox value, the backend expects this
        $(`#custom_text_${currentId}`)
            .keyup(function () {
              $(`#custom_checkbox_${currentId}`).val(this.value)
            })
            .focus();
      }
    })();

    $('.modal-footer:first').prepend('<button id="add_button" type="button" class="btn btn-light me-auto">Add Custom</button>');
    $('#add_button:first').click(addRow);
  }

  function markRowForDeletionOrNot(formsetContainer, $row) {
    var $rows = $row ? $row : $(formsetContainer).find('tbody tr');
    $rows.each(function () {
      var row = $(this);
      if (row.find('input:checkbox:checked').length === 0) {
        row.find('a.delete-form').trigger('click');
      } else {
        row.find('a.unremove').trigger('click');
      }
    });
  }

  c2.forms = {
    initPasswordFields: initPasswordFields,
    markRowForDeletionOrNot: markRowForDeletionOrNot,
    disableBtnOnClick: disableBtnOnClick,
    disableKeypressOnSubmit: disableKeypressOnSubmit,
    makeFormsetManagementData: makeFormsetManagementData,
    setupActionFileFields: setupActionFileFields,
    setupWebHooksForm: setupWebHooksForm,
    enableBatchCheckboxes: enableBatchCheckboxes,
    updateBatchCheckboxes: updateBatchCheckboxes,
    initPowerScheduleForm: initPowerScheduleForm,
    doOrderAction: doOrderAction,
    setUpKubernetesSettingsForm: setUpKubernetesSettingsForm,
    serializeFormAndTableSelection: serializeFormAndTableSelection,
    addToDataTableFormDialog: addToDataTableFormDialog,
    setupSchedulingFields: setupSchedulingFields,
    actionButtonPreview: actionButtonPreview,
    iconPreview: iconPreview,
    addTerraformMappingFields: addTerraformMappingFields,
  };
})(window.c2, window.jQuery, window._);
